/** Study-guide quiz banks for the Linear Algebra Vectors and Matrices guides — 15 MCQs per section. */

export const LA_V_INTRO_QUIZ = [
  {
    prompt: "What is the magnitude of $\\mathbf{v}=\\langle 3,-4\\rangle$?",
    options: ["$7$", "$5$", "$\\sqrt{7}$"],
    answer: "B",
    explanation: "The magnitude is $\\sqrt{3^2+(-4)^2}=\\sqrt{25}=5$.",
  },
  {
    prompt: "The second component of $\\mathbf{u}=(5,-2,9)$ is:",
    options: ["$-2$", "$9$", "$5$"],
    answer: "A",
    explanation: "Components are listed in order; the second entry is $-2$.",
  },
  {
    prompt: "A unit vector in the direction of $\\mathbf{w}=(0,8)$ is:",
    options: ["$(0,1/8)$", "$(0,8)$", "$(0,1)$"],
    answer: "C",
    explanation: "$\\|\\mathbf{w}\\|=8$, so $\\mathbf{w}/8=(0,1)$.",
  },
  {
    prompt: "Distance between $P=(1,2,2)$ and $Q=(4,6,2)$ equals:",
    options: ["$3$", "$5$", "$7$"],
    answer: "B",
    explanation: "$\\sqrt{(4-1)^2+(6-2)^2+(2-2)^2}=\\sqrt{9+16}=5$.",
  },
  {
    prompt: "If $\\mathbf{x}=(2,1,-2)$, then $\\|\\mathbf{x}\\|^2$ equals:",
    options: ["$3$", "$5$", "$9$"],
    answer: "C",
    explanation: "$2^2+1^2+(-2)^2=4+1+4=9$.",
  },
  {
    prompt: "The zero vector in $\\mathbb{R}^3$ is:",
    options: ["$(0,0,0)$", "$(0,0)$", "$(1,1,1)$"],
    answer: "A",
    explanation: "Every component must be zero in three dimensions.",
  },
  {
    prompt: "Two vectors $\\mathbf{a}=(1,4)$ and $\\mathbf{b}=(1,4)$ are equal because:",
    options: ["Matching components in the same order", "Equal magnitudes only", "They are orthogonal"],
    answer: "A",
    explanation: "Vector equality means corresponding components agree.",
  },
  {
    prompt: "The position vector of the point $(-3,5)$ is:",
    options: ["$\\langle -3,-5\\rangle$", "$\\langle -3,5\\rangle$", "$\\langle 3,-5\\rangle$"],
    answer: "B",
    explanation: "The position vector runs from the origin to the point.",
  },
  {
    prompt: "A unit vector parallel to $\\mathbf{v}=\\langle 6,-8\\rangle$ is:",
    options: ["$\\langle 3/4,-1\\rangle$", "$\\langle 6,-8\\rangle$", "$\\langle 3/5,-4/5\\rangle$"],
    answer: "C",
    explanation: "$\\|\\mathbf{v}\\|=10$, so divide by $10$ to get $\\langle 3/5,-4/5\\rangle$.",
  },
  {
    prompt: "If $\\|\\mathbf{u}\\|=4$ and $\\mathbf{u}$ points in the same direction as $\\langle 1,0\\rangle$, then $\\mathbf{u}$ is:",
    options: ["$\\langle 1,0\\rangle$", "$\\langle 4,0\\rangle$", "$\\langle 0,4\\rangle$"],
    answer: "B",
    explanation: "Scale the unit vector $\\langle 1,0\\rangle$ by length $4$.",
  },
  {
    prompt: "Distance from $(0,0,0)$ to $(2,3,6)$ equals:",
    options: ["$11$", "$\\sqrt{11}$", "$7$"],
    answer: "C",
    explanation: "$\\sqrt{4+9+36}=\\sqrt{49}=7$.",
  },
  {
    prompt: "If $\\mathbf{p}=(a,b)$ and $\\mathbf{q}=(c,d)$ are equal, then necessarily:",
    options: ["$a=c$ and $b=d$", "$a+b=c+d$ only", "$\\|\\mathbf{p}\\|=\\|\\mathbf{q}\\|$ only"],
    answer: "A",
    explanation: "Equality requires both components to match.",
  },
  {
    prompt: "The geometric length of $\\mathbf{r}=\\langle 1,2,2\\rangle$ is:",
    options: ["$5$", "$\\sqrt{5}$", "$3$"],
    answer: "C",
    explanation: "$\\sqrt{1+4+4}=3$.",
  },
  {
    prompt: "Which vector has magnitude $13$?",
    options: ["$\\langle 5,12\\rangle$", "$\\langle 3,4\\rangle$", "$\\langle 5,10\\rangle$"],
    answer: "A",
    explanation: "$\\sqrt{25+144}=13$.",
  },
  {
    prompt: "In $\\mathbb{R}^2$, the tip of the position vector $\\langle -1,4\\rangle$ is the point:",
    options: ["$(4,-1)$", "$(-1,4)$", "$(1,-4)$"],
    answer: "B",
    explanation: "The tip is the point with those coordinates.",
  },

  {
    prompt: "The vector $v=(3,-4)$ has Euclidean norm:",
    options: ["$5$", "$7$", "$1$"],
    answer: "A",
    explanation: "$\\|v\\|=\\sqrt{3^2+(-4)^2}=5$.",
  },
  {
    prompt: "The zero vector in $\\mathbb{R}^4$ has:",
    options: ["No components", "Four zero components", "Norm equal to $4$"],
    answer: "B",
    explanation: "Vectors in $\\mathbb{R}^4$ have four components; the zero vector has each equal to zero.",
  },
  {
    prompt: "If $v=(1,2,3)$, then $2v$ equals:",
    options: ["$(3,4,5)$", "$(1,4,9)$", "$(2,4,6)$"],
    answer: "C",
    explanation: "Scalar multiplication multiplies every component by the scalar.",
  },
  {
    prompt: "Vectors $(1,2)$ and $(2,4)$ are:",
    options: ["Parallel", "Orthogonal", "Equal"],
    answer: "A",
    explanation: "The second vector is $2$ times the first.",
  },
  {
    prompt: "The vector $(2,-1,5)$ belongs to:",
    options: ["$\\mathbb{R}^2$", "$\\mathbb{R}^3$", "$\\mathbb{R}^5$"],
    answer: "B",
    explanation: "It has three real components.",
  },
];

export const LA_V_OPS_QUIZ = [
  {
    prompt: "Compute $\\langle 2,-1\\rangle+\\langle 3,4\\rangle$.",
    options: ["$\\langle 5,3\\rangle$", "$\\langle -1,5\\rangle$", "$\\langle 5,5\\rangle$"],
    answer: "A",
    explanation: "Add components: $2+3=5$ and $-1+4=3$.",
  },
  {
    prompt: "Compute $3\\langle 1,-2,4\\rangle$.",
    options: ["$\\langle 3,-2,4\\rangle$", "$\\langle 1,-6,12\\rangle$", "$\\langle 3,-6,12\\rangle$"],
    answer: "C",
    explanation: "Multiply each component by $3$.",
  },
  {
    prompt: "The dot product $\\langle 1,2,3\\rangle\\cdot\\langle 4,-1,0\\rangle$ equals:",
    options: ["$4$", "$2$", "$-2$"],
    answer: "B",
    explanation: "$1\\cdot 4+2\\cdot(-1)+3\\cdot 0=4-2=2$.",
  },
  {
    prompt: "Are $\\mathbf{u}=\\langle 2,-1\\rangle$ and $\\mathbf{v}=\\langle 1,2\\rangle$ orthogonal?",
    options: ["Yes, because they have equal length", "No, because $\\mathbf{u}\\cdot\\mathbf{v}=2$", "Yes, because $\\mathbf{u}\\cdot\\mathbf{v}=0$"],
    answer: "C",
    explanation: "$2\\cdot 1+(-1)\\cdot 2=0$, so they are orthogonal.",
  },
  {
    prompt: "If $\\mathbf{a}\\cdot\\mathbf{b}=6$, $\\|\\mathbf{a}\\|=3$, $\\|\\mathbf{b}\\|=4$, then $\\cos\\theta$ equals:",
    options: ["$1/2\\sqrt{2}$", "$1/2$", "$2$"],
    answer: "B",
    explanation: "$\\cos\\theta=(\\mathbf{a}\\cdot\\mathbf{b})/(\\|\\mathbf{a}\\|\\|\\mathbf{b}\\|)=6/12=1/2$.",
  },
  {
    prompt: "The projection $\\operatorname{proj}_{\\mathbf{u}}\\mathbf{v}$ for $\\mathbf{u}=\\langle 1,0\\rangle$, $\\mathbf{v}=\\langle 3,4\\rangle$ is:",
    options: ["$\\langle 3,0\\rangle$", "$\\langle 0,4\\rangle$", "$\\langle 3,4\\rangle$"],
    answer: "A",
    explanation: "$(\\mathbf{v}\\cdot\\mathbf{u}/\\|\\mathbf{u}\\|^2)\\mathbf{u}=3\\langle 1,0\\rangle$.",
  },
  {
    prompt: "$\\mathbf{i}\\times\\mathbf{j}$ equals:",
    options: ["$\\mathbf{0}$", "$-\\mathbf{k}$", "$\\mathbf{k}$"],
    answer: "C",
    explanation: "Right-hand rule: $\\mathbf{i}\\times\\mathbf{j}=\\mathbf{k}$.",
  },
  {
    prompt: "Compute $\\langle 1,2,0\\rangle\\times\\langle 0,3,4\\rangle$.",
    options: ["$\\langle -8,4,3\\rangle$", "$\\langle 8,-4,3\\rangle$", "$\\langle 8,4,-3\\rangle$"],
    answer: "B",
    explanation: "Determinant formula yields $\\langle 8,-4,3\\rangle$.",
  },
  {
    prompt: "Area of the parallelogram spanned by $\\langle 1,0,0\\rangle$ and $\\langle 1,1,0\\rangle$ is:",
    options: ["$1$", "$2$", "$\\sqrt{2}$"],
    answer: "A",
    explanation: "Cross product is $\\langle 0,0,1\\rangle$ with magnitude $1$.",
  },
  {
    prompt: "The scalar triple product $\\mathbf{a}\\cdot(\\mathbf{b}\\times\\mathbf{c})$ for $\\mathbf{a}=\\langle 1,0,0\\rangle$, $\\mathbf{b}=\\langle 0,1,0\\rangle$, $\\mathbf{c}=\\langle 0,0,1\\rangle$ equals:",
    options: ["$1$", "$0$", "$-1$"],
    answer: "A",
    explanation: "$\\mathbf{b}\\times\\mathbf{c}=\\mathbf{i}$ and $\\mathbf{a}\\cdot\\mathbf{i}=1$.",
  },
  {
    prompt: "Compute $\\langle 4,1\\rangle-\\langle 1,-3\\rangle$.",
    options: ["$\\langle 5,-2\\rangle$", "$\\langle 3,4\\rangle$", "$\\langle 3,-4\\rangle$"],
    answer: "B",
    explanation: "$4-1=3$ and $1-(-3)=4$.",
  },
  {
    prompt: "If $\\mathbf{u}\\cdot\\mathbf{v}=-\\|\\mathbf{u}\\|\\|\\mathbf{v}\\|$, the angle between them is:",
    options: ["$0$", "$\\pi/2$", "$\\pi$"],
    answer: "C",
    explanation: "$\\cos\\theta=-1$ means the vectors are opposite.",
  },
  {
    prompt: "For $\\mathbf{u}=\\langle 2,2\\rangle$ and $\\mathbf{v}=\\langle 1,0\\rangle$, $\\operatorname{proj}_{\\mathbf{u}}\\mathbf{v}$ equals:",
    options: ["$\\langle 2,0\\rangle$", "$\\langle 1/2,1/2\\rangle$", "$\\langle 1,1\\rangle$"],
    answer: "B",
    explanation: "$(\\mathbf{v}\\cdot\\mathbf{u}/\\|\\mathbf{u}\\|^2)\\mathbf{u}=(2/8)\\langle 2,2\\rangle=\\langle 1/2,1/2\\rangle$.",
  },
  {
    prompt: "For $\\mathbf{a}=\\langle 1,2,2\\rangle$ and $\\mathbf{b}=\\langle 2,0,0\\rangle$, $\\|\\mathbf{a}\\times\\mathbf{b}\\|$ equals:",
    options: ["$2\\sqrt{2}$", "$4$", "$4\\sqrt{2}$"],
    answer: "C",
    explanation: "Cross product $\\langle 0,4,-4\\rangle$ has magnitude $\\sqrt{32}=4\\sqrt{2}$.",
  },
  {
    prompt: "The vector $\\langle 1,-1,2\\rangle\\times\\langle 2,0,1\\rangle$ equals:",
    options: ["$\\langle -1,3,2\\rangle$", "$\\langle 1,-3,-2\\rangle$", "$\\langle -1,-3,2\\rangle$"],
    answer: "A",
    explanation: "$\\mathbf{i}((-1)(1)-2\\cdot 0)-\\mathbf{j}(1\\cdot 1-2\\cdot 2)+\\mathbf{k}(0-(-2))=\\langle -1,3,2\\rangle$.",
  },

  {
    prompt: "For $u=(1,2)$ and $v=(3,4)$, $u\\cdot v$ is:",
    options: ["$7$", "$11$", "$10$"],
    answer: "B",
    explanation: "$1(3)+2(4)=11$.",
  },
  {
    prompt: "If $u\\cdot v=0$ for nonzero vectors, then $u$ and $v$ are:",
    options: ["Parallel", "Equal", "Orthogonal"],
    answer: "C",
    explanation: "Zero dot product is the Euclidean orthogonality criterion.",
  },
  {
    prompt: "For $u=(2,0)$, the unit vector in the direction of $u$ is:",
    options: ["$(1,0)$", "$(2,0)$", "$(0,1)$"],
    answer: "A",
    explanation: "Divide by $\\|u\\|=2$.",
  },
  {
    prompt: "The Cauchy–Schwarz inequality states:",
    options: ["$|u\\cdot v|>\\|u\\|\\|v\\|$", "$|u\\cdot v|\\le \\|u\\|\\|v\\|$", "$u\\cdot v=\\|u\\|+\\|v\\|$"],
    answer: "B",
    explanation: "The absolute dot product cannot exceed the product of the norms.",
  },
  {
    prompt: "If $u$ and $v$ are unit vectors with $u\\cdot v=1$, then they point:",
    options: ["In perpendicular directions", "In opposite directions", "In the same direction"],
    answer: "C",
    explanation: "For unit vectors, $u\\cdot v=\\cos\\theta=1$, so $\\theta=0$.",
  },
];

export const LA_V_SPAN_QUIZ = [
  {
    prompt: "The span of $\\{\\langle 1,0\\rangle\\}$ in $\\mathbb{R}^2$ is:",
    options: ["All of $\\mathbb{R}^2$", "The $x$-axis", "Only the origin"],
    answer: "B",
    explanation: "Scalar multiples of $\\langle 1,0\\rangle$ fill the horizontal axis.",
  },
  {
    prompt: "Does $\\langle 2,4\\rangle$ lie in $\\operatorname{Span}\\{\\langle 1,2\\rangle\\}$?",
    options: ["Yes, because $\\langle 2,4\\rangle=2\\langle 1,2\\rangle$", "No, the vectors are orthogonal", "Only if both are unit vectors"],
    answer: "A",
    explanation: "It is exactly twice $\\langle 1,2\\rangle$.",
  },
  {
    prompt: "The set $\\{\\langle 1,0\\rangle,\\langle 0,1\\rangle\\}$ spans:",
    options: ["Only a line", "Only the origin", "$\\mathbb{R}^2$"],
    answer: "C",
    explanation: "These are the standard basis vectors of $\\mathbb{R}^2$.",
  },
  {
    prompt: "If $\\mathbf{v}=2\\mathbf{u}$, then $\\operatorname{Span}\\{\\mathbf{u},\\mathbf{v}\\}$ is:",
    options: ["All of $\\mathbb{R}^2$", "A plane", "A line through the origin (or $\\{\\mathbf{0}\\}$)"],
    answer: "C",
    explanation: "The two vectors are parallel, so their span is one-dimensional.",
  },
  {
    prompt: "Coordinates of $\\langle 5,7\\rangle$ relative to the standard basis of $\\mathbb{R}^2$ are:",
    options: ["$(5,7)$", "$(1,1)$", "$(7,5)$"],
    answer: "A",
    explanation: "$\\langle 5,7\\rangle=5\\mathbf{e}_1+7\\mathbf{e}_2$.",
  },
  {
    prompt: "A basis of a subspace must be:",
    options: ["Any spanning set", "Linearly independent and spanning", "Any independent set of size 2"],
    answer: "B",
    explanation: "Both independence and spanning are required.",
  },
  {
    prompt: "Dimension of $\\operatorname{Span}\\{\\langle 1,0,0\\rangle,\\langle 0,1,0\\rangle\\}$ is:",
    options: ["$1$", "$3$", "$2$"],
    answer: "C",
    explanation: "Two independent vectors span a $2$-dimensional subspace of $\\mathbb{R}^3$.",
  },
  {
    prompt: "Does $\\{\\langle 1,1\\rangle,\\langle 2,3\\rangle\\}$ span $\\mathbb{R}^2$?",
    options: ["Yes; the vectors are independent in $\\mathbb{R}^2$", "No; they are parallel", "Only the first vector is needed"],
    answer: "A",
    explanation: "The matrix with these columns has nonzero determinant $1$.",
  },
  {
    prompt: "The standard basis of $\\mathbb{R}^3$ is:",
    options: ["$\\{\\mathbf{0}\\}$", "$\\{\\mathbf{e}_1,\\mathbf{e}_2,\\mathbf{e}_3\\}$", "$\\{\\langle 1,1,1\\rangle\\}$"],
    answer: "B",
    explanation: "The three unit coordinate vectors form the standard basis.",
  },
  {
    prompt: "Is $\\langle 0,1,1\\rangle$ in $\\operatorname{Span}\\{\\langle 1,0,0\\rangle,\\langle 0,1,0\\rangle\\}$?",
    options: ["No; the third component cannot be produced", "Yes; take coefficients $0$ and $1$", "Yes; any vector in $\\mathbb{R}^3$ is"],
    answer: "A",
    explanation: "Linear combinations have third component $0$.",
  },
  {
    prompt: "If $B=\\{\\mathbf{b}_1,\\mathbf{b}_2\\}$ is a basis of $\\mathbb{R}^2$ and $[\\mathbf{x}]_B=(3,-1)$, then $\\mathbf{x}$ equals:",
    options: ["$\\mathbf{b}_1+3\\mathbf{b}_2$", "$3\\mathbf{b}_1-\\mathbf{b}_2$", "$-3\\mathbf{b}_1+\\mathbf{b}_2$"],
    answer: "B",
    explanation: "Coordinates are the weights in the linear combination.",
  },
  {
    prompt: "Any spanning set of $\\mathbb{R}^3$ must contain at least how many vectors?",
    options: ["$2$", "$1$", "$3$"],
    answer: "C",
    explanation: "Dimension $3$ requires at least three spanning vectors.",
  },
  {
    prompt: "The span of the empty set is conventionally:",
    options: ["Undefined always", "$\\mathbb{R}^n$", "$\\{\\mathbf{0}\\}$"],
    answer: "C",
    explanation: "The empty linear combination is the zero vector.",
  },
  {
    prompt: "If three vectors in $\\mathbb{R}^2$ span $\\mathbb{R}^2$, then:",
    options: ["They are linearly dependent", "They form a basis", "They must be orthogonal"],
    answer: "A",
    explanation: "More than $2$ vectors in $\\mathbb{R}^2$ cannot be independent.",
  },
  {
    prompt: "For $\\mathbf{u}=\\langle 1,2,3\\rangle$ and $\\mathbf{v}=\\langle 2,4,6\\rangle$, $\\operatorname{Span}\\{\\mathbf{u},\\mathbf{v}\\}$ equals:",
    options: ["$\\mathbb{R}^3$", "$\\operatorname{Span}\\{\\mathbf{u}\\}$", "A plane through three non-collinear points"],
    answer: "B",
    explanation: "$\\mathbf{v}=2\\mathbf{u}$, so both generate the same line.",
  },

  {
    prompt: "The span of a single nonzero vector in $\\mathbb{R}^3$ is:",
    options: ["A plane not through the origin", "All of $\\mathbb{R}^3$", "A line through the origin"],
    answer: "C",
    explanation: "All scalar multiples of one nonzero vector form a line through the origin.",
  },
  {
    prompt: "The vectors $(1,0)$ and $(0,1)$ span:",
    options: ["$\\mathbb{R}^2$", "Only the x-axis", "Only the y-axis"],
    answer: "A",
    explanation: "Every $(a,b)$ equals $a(1,0)+b(0,1)$.",
  },
  {
    prompt: "If $v$ is a linear combination of $v_1,v_2$, then $v$ belongs to:",
    options: ["$\\ker(v_1)$", "$\\operatorname{span}\\{v_1,v_2\\}$", "No vector space"],
    answer: "B",
    explanation: "Span is exactly the set of all linear combinations.",
  },
  {
    prompt: "Adding a vector already in a set's span will:",
    options: ["Always increase its dimension", "Make the span empty", "Leave the span unchanged"],
    answer: "C",
    explanation: "A redundant vector contributes no new direction.",
  },
  {
    prompt: "A basis for a subspace must both:",
    options: ["Span the subspace and be linearly independent", "Contain the zero vector and span", "Contain every vector in the subspace"],
    answer: "A",
    explanation: "Basis vectors provide a nonredundant spanning set.",
  },
];

export const LA_V_INDEP_QUIZ = [
  {
    prompt: "The set $\\{\\langle 1,0\\rangle,\\langle 0,1\\rangle\\}$ is:",
    options: ["Linearly independent", "Linearly dependent", "Neither, because it spans"],
    answer: "A",
    explanation: "Only the trivial combination gives the zero vector.",
  },
  {
    prompt: "Is $\\{\\langle 1,2\\rangle,\\langle 2,4\\rangle\\}$ linearly independent?",
    options: ["Yes; they span $\\mathbb{R}^2$", "No; the second is twice the first", "Yes; both are nonzero"],
    answer: "B",
    explanation: "A nontrivial relation $2\\mathbf{v}_1-\\mathbf{v}_2=\\mathbf{0}$ exists.",
  },
  {
    prompt: "Three vectors in $\\mathbb{R}^2$ must be:",
    options: ["A basis of $\\mathbb{R}^2$", "Linearly independent", "Linearly dependent"],
    answer: "C",
    explanation: "Any set with more than $n$ vectors in $\\mathbb{R}^n$ is dependent.",
  },
  {
    prompt: "The equation $c_1\\mathbf{v}_1+c_2\\mathbf{v}_2=\\mathbf{0}$ has only the trivial solution iff:",
    options: ["The vectors have equal length", "Their span is a line", "$\\{\\mathbf{v}_1,\\mathbf{v}_2\\}$ is independent"],
    answer: "C",
    explanation: "That is the definition of linear independence.",
  },
  {
    prompt: "Columns of $\\begin{pmatrix}1&2\\\\3&4\\end{pmatrix}$ are independent because:",
    options: ["$\\det=0$", "$\\det= -2\\ne 0$", "The matrix is symmetric"],
    answer: "B",
    explanation: "Nonzero determinant means full column rank.",
  },
  {
    prompt: "For $\\{\\langle 1,1,0\\rangle,\\langle 0,1,1\\rangle,\\langle 1,2,1\\rangle\\}$, a dependence relation is:",
    options: ["$\\mathbf{v}_1+\\mathbf{v}_2-\\mathbf{v}_3=\\mathbf{0}$", "Only the zero combination works", "$\\mathbf{v}_1-\\mathbf{v}_2=\\mathbf{0}$"],
    answer: "A",
    explanation: "$\\langle 1,1,0\\rangle+\\langle 0,1,1\\rangle=\\langle 1,2,1\\rangle$.",
  },
  {
    prompt: "If $A$ is $3\\times 3$ with $\\operatorname{rank}(A)=2$, its columns are:",
    options: ["Linearly dependent", "Linearly independent", "A basis of $\\mathbb{R}^3$"],
    answer: "A",
    explanation: "Rank less than $3$ means the three columns are dependent.",
  },
  {
    prompt: "The set $\\{\\mathbf{0},\\langle 1,0\\rangle\\}$ is:",
    options: ["Independent", "Dependent, because it contains $\\mathbf{0}$", "A basis of $\\mathbb{R}^2$"],
    answer: "B",
    explanation: "Any set containing the zero vector is dependent.",
  },
  {
    prompt: "Two nonzero parallel vectors in $\\mathbb{R}^n$ are:",
    options: ["Orthogonal", "Independent", "Dependent"],
    answer: "C",
    explanation: "One is a scalar multiple of the other.",
  },
  {
    prompt: "If $\\det\\begin{pmatrix}a&b\\\\c&d\\end{pmatrix}=0$, the columns are:",
    options: ["Independent", "Orthogonal", "Dependent"],
    answer: "C",
    explanation: "Vanishing determinant means dependent columns.",
  },
  {
    prompt: "Independence of $\\{\\langle 1,0,0\\rangle,\\langle 0,1,0\\rangle,\\langle 0,0,1\\rangle\\}$ follows because:",
    options: ["Their sum is nonzero", "They form the standard basis", "There are three of them"],
    answer: "B",
    explanation: "The standard basis is independent by construction.",
  },
  {
    prompt: "A set of $4$ vectors in $\\mathbb{R}^3$:",
    options: ["Cannot be independent", "Must span $\\mathbb{R}^3$", "Must be a basis"],
    answer: "A",
    explanation: "More vectors than the ambient dimension forces dependence.",
  },
  {
    prompt: "If the only solution of $A\\mathbf{x}=\\mathbf{0}$ is $\\mathbf{x}=\\mathbf{0}$ for a square $A$, then the columns of $A$ are:",
    options: ["Orthogonal to each other", "Dependent", "Independent"],
    answer: "C",
    explanation: "Trivial nullspace means independent columns.",
  },
  {
    prompt: "For $\\mathbf{u}=\\langle 1,2\\rangle$, $\\mathbf{v}=\\langle 3,1\\rangle$, solving $c_1\\mathbf{u}+c_2\\mathbf{v}=\\mathbf{0}$ yields:",
    options: ["Only $c_1=c_2=0$", "Infinitely many solutions", "$c_1=3$, $c_2=-1$"],
    answer: "A",
    explanation: "Determinant $1\\cdot 1-2\\cdot 3=-5\\ne 0$.",
  },
  {
    prompt: "If columns of a $2\\times 2$ matrix are independent, then $\\operatorname{rank}(A)$ equals:",
    options: ["$1$", "$2$", "$0$"],
    answer: "B",
    explanation: "Two independent columns give full rank.",
  },

  {
    prompt: "Any set containing the zero vector is:",
    options: ["Linearly dependent", "Always orthogonal", "Always a basis"],
    answer: "A",
    explanation: "The zero vector gives a nontrivial dependence relation immediately.",
  },
  {
    prompt: "Two vectors are linearly dependent exactly when one is:",
    options: ["Orthogonal to the other", "A scalar multiple of the other", "The same length as the other"],
    answer: "B",
    explanation: "For two vectors, dependence means they lie on the same line through the origin.",
  },
  {
    prompt: "Three vectors in $\\mathbb{R}^2$ must be:",
    options: ["Linearly independent", "Orthonormal", "Linearly dependent"],
    answer: "C",
    explanation: "At most two linearly independent vectors can exist in a two-dimensional space.",
  },
  {
    prompt: "The columns of an invertible $3\\times3$ matrix are:",
    options: ["Linearly independent", "Linearly dependent", "All zero"],
    answer: "A",
    explanation: "Invertibility is equivalent to having a pivot in every column.",
  },
  {
    prompt: "A set of $n$ linearly independent vectors in $\\mathbb{R}^n$ is automatically:",
    options: ["A proper subspace only", "A basis for $\\mathbb{R}^n$", "Linearly dependent"],
    answer: "B",
    explanation: "In an $n$-dimensional space, $n$ independent vectors also span the whole space.",
  },
];

export const LA_M_INTRO_QUIZ = [
  {
    prompt: "The matrix $\\begin{pmatrix}1&2&3\\\\4&5&6\\end{pmatrix}$ has size:",
    options: ["$2\\times 3$", "$3\\times 2$", "$6\\times 1$"],
    answer: "A",
    explanation: "Two rows and three columns.",
  },
  {
    prompt: "Entry $a_{21}$ of $\\begin{pmatrix}7&8\\\\9&10\\end{pmatrix}$ is:",
    options: ["$8$", "$7$", "$9$"],
    answer: "C",
    explanation: "Row $2$, column $1$ is $9$.",
  },
  {
    prompt: "The standard matrix of reflection across the $x$-axis in $\\mathbb{R}^2$ is:",
    options: ["$\\begin{pmatrix}-1&0\\\\0&1\\end{pmatrix}$", "$\\begin{pmatrix}1&0\\\\0&-1\\end{pmatrix}$", "$\\begin{pmatrix}0&1\\\\1&0\\end{pmatrix}$"],
    answer: "B",
    explanation: "$(x,y)\\mapsto(x,-y)$.",
  },
  {
    prompt: "The $2\\times 2$ identity matrix is:",
    options: ["$\\begin{pmatrix}1&1\\\\1&1\\end{pmatrix}$", "$\\begin{pmatrix}1&0\\\\0&1\\end{pmatrix}$", "$\\begin{pmatrix}0&1\\\\1&0\\end{pmatrix}$"],
    answer: "B",
    explanation: "Ones on the diagonal and zeros elsewhere.",
  },
  {
    prompt: "A diagonal matrix can have nonzero entries only:",
    options: ["Above the diagonal", "In the first row", "On the main diagonal"],
    answer: "C",
    explanation: "Off-diagonal entries must be zero.",
  },
  {
    prompt: "The transpose of $\\begin{pmatrix}1&2\\\\3&4\\\\5&6\\end{pmatrix}$ is:",
    options: ["$\\begin{pmatrix}1&3&5\\\\2&4&6\\end{pmatrix}$", "$\\begin{pmatrix}1&2&3\\\\4&5&6\\end{pmatrix}$", "$\\begin{pmatrix}6&5\\\\4&3\\\\2&1\\end{pmatrix}$"],
    answer: "A",
    explanation: "Rows become columns.",
  },
  {
    prompt: "The zero matrix of size $2\\times 2$ is:",
    options: ["$\\begin{pmatrix}0&1\\\\1&0\\end{pmatrix}$", "$\\begin{pmatrix}1&0\\\\0&1\\end{pmatrix}$", "$\\begin{pmatrix}0&0\\\\0&0\\end{pmatrix}$"],
    answer: "C",
    explanation: "Every entry is $0$.",
  },
  {
    prompt: "A symmetric matrix satisfies:",
    options: ["$A^T=A$", "$A^2=I$", "$A^T=-A$"],
    answer: "A",
    explanation: "Equals its own transpose.",
  },
  {
    prompt: "The standard matrix for scaling by $3$ in $\\mathbb{R}^2$ is:",
    options: ["$\\begin{pmatrix}3&3\\\\3&3\\end{pmatrix}$", "$\\begin{pmatrix}3&0\\\\0&3\\end{pmatrix}$", "$\\begin{pmatrix}1&0\\\\0&3\\end{pmatrix}$"],
    answer: "B",
    explanation: "Both axes stretch by factor $3$.",
  },
  {
    prompt: "Upper triangular $3\\times 3$ matrices have zeros:",
    options: ["Strictly above the diagonal", "Strictly below the diagonal", "On the diagonal"],
    answer: "B",
    explanation: "Entries $a_{ij}$ with $i>j$ vanish.",
  },
  {
    prompt: "Rotation by $90^\\circ$ counterclockwise in $\\mathbb{R}^2$ has matrix:",
    options: ["$\\begin{pmatrix}0&1\\\\-1&0\\end{pmatrix}$", "$\\begin{pmatrix}1&0\\\\0&-1\\end{pmatrix}$", "$\\begin{pmatrix}0&-1\\\\1&0\\end{pmatrix}$"],
    answer: "C",
    explanation: "$(x,y)\\mapsto(-y,x)$.",
  },
  {
    prompt: "Projection onto the $x$-axis has standard matrix:",
    options: ["$\\begin{pmatrix}1&0\\\\0&0\\end{pmatrix}$", "$\\begin{pmatrix}0&0\\\\0&1\\end{pmatrix}$", "$\\begin{pmatrix}1&1\\\\0&0\\end{pmatrix}$"],
    answer: "A",
    explanation: "$(x,y)\\mapsto(x,0)$.",
  },
  {
    prompt: "If $A$ is $m\\times n$, it maps $\\mathbb{R}^n$ into:",
    options: ["$\\mathbb{R}^{mn}$", "$\\mathbb{R}^n$", "$\\mathbb{R}^m$"],
    answer: "C",
    explanation: "Columns live in $\\mathbb{R}^m$.",
  },
  {
    prompt: "Entry $a_{13}$ of $\\begin{pmatrix}2&0&5\\\\1&3&4\\end{pmatrix}$ is:",
    options: ["$5$", "$4$", "$0$"],
    answer: "A",
    explanation: "First row, third column.",
  },
  {
    prompt: "A linear map $T:\\mathbb{R}^2\\to\\mathbb{R}^2$ is completely determined by:",
    options: ["Its determinant alone", "$T(\\mathbf{e}_1)$ and $T(\\mathbf{e}_2)$", "Only $T(\\mathbf{0})$"],
    answer: "B",
    explanation: "Images of the standard basis form the columns of the matrix.",
  },

  {
    prompt: "A matrix with $3$ rows and $5$ columns has size:",
    options: ["$5\\times3$", "$3\\times5$", "$15\\times1$"],
    answer: "B",
    explanation: "Matrix dimensions are listed as rows by columns.",
  },
  {
    prompt: "In a $4\\times2$ matrix, the entry $a_{31}$ lies in:",
    options: ["Row 1, column 3", "Row 3, column 2", "Row 3, column 1"],
    answer: "C",
    explanation: "The first subscript is the row and the second is the column.",
  },
  {
    prompt: "A square matrix has:",
    options: ["The same number of rows and columns", "Exactly one row", "Only zero entries"],
    answer: "A",
    explanation: "Square means dimensions $n\\times n$.",
  },
  {
    prompt: "The $n\\times n$ identity matrix has:",
    options: ["Zeros everywhere", "Ones on the main diagonal and zeros elsewhere", "Ones everywhere"],
    answer: "B",
    explanation: "The identity matrix leaves vectors unchanged under multiplication.",
  },
  {
    prompt: "A column vector with four entries can be viewed as a:",
    options: ["$1\\times4$ matrix", "$4\\times4$ matrix", "$4\\times1$ matrix"],
    answer: "C",
    explanation: "A column vector has one column.",
  },
];

export const LA_M_OPS_QUIZ = [
  {
    prompt: "Compute $\\begin{pmatrix}1&2\\\\3&4\\end{pmatrix}+\\begin{pmatrix}5&0\\\\1&1\\end{pmatrix}$.",
    options: ["$\\begin{pmatrix}5&2\\\\3&5\\end{pmatrix}$", "$\\begin{pmatrix}6&2\\\\4&4\\end{pmatrix}$", "$\\begin{pmatrix}6&2\\\\4&5\\end{pmatrix}$"],
    answer: "C",
    explanation: "Add entrywise.",
  },
  {
    prompt: "Compute $2\\begin{pmatrix}1&-1\\\\0&3\\end{pmatrix}$.",
    options: ["$\\begin{pmatrix}2&-2\\\\0&6\\end{pmatrix}$", "$\\begin{pmatrix}2&-1\\\\0&3\\end{pmatrix}$", "$\\begin{pmatrix}1&-2\\\\0&6\\end{pmatrix}$"],
    answer: "A",
    explanation: "Scale every entry by $2$.",
  },
  {
    prompt: "Product $\\begin{pmatrix}1&2\\\\0&1\\end{pmatrix}\\begin{pmatrix}3&0\\\\1&4\\end{pmatrix}$ equals:",
    options: ["$\\begin{pmatrix}5&8\\\\0&4\\end{pmatrix}$", "$\\begin{pmatrix}5&8\\\\1&4\\end{pmatrix}$", "$\\begin{pmatrix}3&0\\\\1&4\\end{pmatrix}$"],
    answer: "B",
    explanation: "Row-column: first entry $1\\cdot 3+2\\cdot 1=5$, and so on.",
  },
  {
    prompt: "Can a $2\\times 3$ matrix multiply a $2\\times 2$ matrix on the right?",
    options: ["Yes; always", "No; inner dimensions $3$ and $2$ disagree", "Only if both are square"],
    answer: "B",
    explanation: "Need the middle sizes to match.",
  },
  {
    prompt: "In general $AB$ and $BA$:",
    options: ["Need not be equal", "Are always negatives", "Are always equal"],
    answer: "A",
    explanation: "Matrix multiplication is not commutative.",
  },
  {
    prompt: "If $A=\\begin{pmatrix}0&1\\\\0&0\\end{pmatrix}$, then $A^2$ equals:",
    options: ["$I$", "$A$", "$\\begin{pmatrix}0&0\\\\0&0\\end{pmatrix}$"],
    answer: "C",
    explanation: "Direct multiplication yields the zero matrix.",
  },
  {
    prompt: "$(AB)^T$ equals:",
    options: ["$A^TB^T$", "$B^TA^T$", "$AB$"],
    answer: "B",
    explanation: "Transpose reverses the product order.",
  },
  {
    prompt: "$\\operatorname{tr}\\begin{pmatrix}2&7\\\\0&5\\end{pmatrix}$ equals:",
    options: ["$7$", "$10$", "$2$"],
    answer: "A",
    explanation: "Trace is the sum of diagonal entries $2+5=7$.",
  },
  {
    prompt: "$\\begin{pmatrix}1&0\\\\0&-1\\end{pmatrix}\\begin{pmatrix}0&1\\\\1&0\\end{pmatrix}$ equals:",
    options: ["$\\begin{pmatrix}1&0\\\\0&-1\\end{pmatrix}$", "$\\begin{pmatrix}0&-1\\\\1&0\\end{pmatrix}$", "$\\begin{pmatrix}0&1\\\\-1&0\\end{pmatrix}$"],
    answer: "C",
    explanation: "Compute the product of the two factors.",
  },
  {
    prompt: "If $A$ is $3\\times 2$ and $B$ is $2\\times 4$, then $AB$ has size:",
    options: ["$2\\times 2$", "$3\\times 4$", "$4\\times 3$"],
    answer: "B",
    explanation: "Outer dimensions give the product size.",
  },
  {
    prompt: "$\\operatorname{tr}(A+B)$ equals:",
    options: ["$\\operatorname{tr}(AB)$", "$(\\operatorname{tr}A)(\\operatorname{tr}B)$", "$\\operatorname{tr}A+\\operatorname{tr}B$"],
    answer: "C",
    explanation: "Trace is linear.",
  },
  {
    prompt: "For $A=\\begin{pmatrix}1&1\\\\0&1\\end{pmatrix}$, $A^3$ equals:",
    options: ["$\\begin{pmatrix}1&3\\\\0&1\\end{pmatrix}$", "$\\begin{pmatrix}1&2\\\\0&1\\end{pmatrix}$", "$\\begin{pmatrix}1&1\\\\0&1\\end{pmatrix}$"],
    answer: "A",
    explanation: "Inductively $A^n=\\begin{pmatrix}1&n\\\\0&1\\end{pmatrix}$.",
  },
  {
    prompt: "Scalar multiple: $(-1)\\begin{pmatrix}2&3\\\\4&5\\end{pmatrix}$ equals:",
    options: ["$\\begin{pmatrix}2&-3\\\\-4&5\\end{pmatrix}$", "$\\begin{pmatrix}-2&3\\\\4&-5\\end{pmatrix}$", "$\\begin{pmatrix}-2&-3\\\\-4&-5\\end{pmatrix}$"],
    answer: "C",
    explanation: "Negate every entry.",
  },
  {
    prompt: "If $A$ is square, $\\operatorname{tr}(A^T)$ equals:",
    options: ["$-\\operatorname{tr}A$", "$\\operatorname{tr}A$", "$0$"],
    answer: "B",
    explanation: "Diagonal entries are unchanged by transpose.",
  },
  {
    prompt: "Product $\\begin{pmatrix}2&1\\end{pmatrix}\\begin{pmatrix}3\\\\4\\end{pmatrix}$ equals:",
    options: ["$\\begin{pmatrix}10\\end{pmatrix}$", "$\\begin{pmatrix}5\\end{pmatrix}$", "$\\begin{pmatrix}6&4\\end{pmatrix}$"],
    answer: "A",
    explanation: "$2\\cdot 3+1\\cdot 4=10$ as a $1\\times 1$ matrix.",
  },

  {
    prompt: "If $A$ and $B$ are both $2\\times3$, then $A+B$ has size:",
    options: ["$3\\times2$", "$2\\times2$", "$2\\times3$"],
    answer: "C",
    explanation: "Matrix addition is entrywise and preserves dimensions.",
  },
  {
    prompt: "If $A$ is $2\\times3$ and $B$ is $3\\times4$, then $AB$ has size:",
    options: ["$2\\times4$", "$3\\times3$", "$4\\times2$"],
    answer: "A",
    explanation: "The inner dimensions match and the outer dimensions remain.",
  },
  {
    prompt: "For compatible matrices, matrix multiplication is generally:",
    options: ["Always commutative", "Not commutative", "Undefined in both orders"],
    answer: "B",
    explanation: "In general $AB\\neq BA$, and one order may even be undefined.",
  },
  {
    prompt: "The transpose of a $2\\times5$ matrix has size:",
    options: ["$2\\times5$", "$5\\times5$", "$5\\times2$"],
    answer: "C",
    explanation: "Transposition swaps rows and columns.",
  },
  {
    prompt: "For any compatible matrices $A,B$, $(AB)^T$ equals:",
    options: ["$B^TA^T$", "$A^TB^T$", "$AB$"],
    answer: "A",
    explanation: "Transposition reverses the order of a product.",
  },
];

export const LA_M_DET_QUIZ = [
  {
    prompt: "$\\det\\begin{pmatrix}3&1\\\\2&4\\end{pmatrix}$ equals:",
    options: ["$14$", "$10$", "$5$"],
    answer: "B",
    explanation: "$3\\cdot 4-1\\cdot 2=12-2=10$.",
  },
  {
    prompt: "$\\det\\begin{pmatrix}1&2&0\\\\0&3&4\\\\0&0&5\\end{pmatrix}$ equals:",
    options: ["$12$", "$0$", "$15$"],
    answer: "C",
    explanation: "Triangular: product of diagonal entries $1\\cdot 3\\cdot 5=15$.",
  },
  {
    prompt: "If $\\det A=4$ and $\\det B=3$ for $n\\times n$ matrices, $\\det(AB)$ equals:",
    options: ["$12$", "$7$", "$1$"],
    answer: "A",
    explanation: "$\\det(AB)=\\det A\\det B$.",
  },
  {
    prompt: "Swapping two rows of a matrix multiplies the determinant by:",
    options: ["$-1$", "$0$", "$2$"],
    answer: "A",
    explanation: "An elementary row swap changes the sign.",
  },
  {
    prompt: "If $\\det A=5$ for a $2\\times 2$ matrix, $\\det(3A)$ equals:",
    options: ["$15$", "$5/3$", "$45$"],
    answer: "C",
    explanation: "$\\det(kA)=k^n\\det A$ with $n=2$: $9\\cdot 5=45$.",
  },
  {
    prompt: "A square matrix is singular precisely when its determinant is:",
    options: ["Negative", "$0$", "$1$"],
    answer: "B",
    explanation: "Zero determinant iff noninvertible.",
  },
  {
    prompt: "$\\det\\begin{pmatrix}2&0&0\\\\1&3&0\\\\4&5&6\\end{pmatrix}$ equals:",
    options: ["$0$", "$36$", "$18$"],
    answer: "B",
    explanation: "Lower triangular: $2\\cdot 3\\cdot 6=36$.",
  },
  {
    prompt: "If $\\det A=2$, then $\\det(A^{-1})$ equals:",
    options: ["$1/2$", "$-2$", "$2$"],
    answer: "A",
    explanation: "$\\det(A^{-1})=1/\\det A$.",
  },
  {
    prompt: "Cofactor expansion of $\\begin{pmatrix}1&0&2\\\\0&3&0\\\\4&0&5\\end{pmatrix}$ along the middle row yields determinant:",
    options: ["$15$", "$9$", "$-9$"],
    answer: "C",
    explanation: "Only the middle entry $3$ survives: $3(-1)^{2+2}\\det\\begin{pmatrix}1&2\\\\4&5\\end{pmatrix}=3(5-8)=-9$.",
  },
  {
    prompt: "Area of the parallelogram with sides $\\langle 2,0\\rangle$ and $\\langle 1,3\\rangle$ equals:",
    options: ["$5$", "$3$", "$6$"],
    answer: "C",
    explanation: "$|\\det\\begin{pmatrix}2&1\\\\0&3\\end{pmatrix}|=6$.",
  },
  {
    prompt: "Multiplying one row by $4$ multiplies $\\det$ by:",
    options: ["$1/4$", "$4$", "$16$"],
    answer: "B",
    explanation: "A single-row scale scales the determinant by the same factor.",
  },
  {
    prompt: "If two rows of $A$ are identical, $\\det A$ equals:",
    options: ["$0$", "$1$", "$2$"],
    answer: "A",
    explanation: "Dependent rows force a zero determinant.",
  },
  {
    prompt: "$\\det I_n$ equals:",
    options: ["$0$", "$1$", "$n$"],
    answer: "B",
    explanation: "Identity is triangular with ones on the diagonal.",
  },
  {
    prompt: "For $A=\\begin{pmatrix}0&1\\\\-2&3\\end{pmatrix}$, $\\det A$ equals:",
    options: ["$2$", "$3$", "$-2$"],
    answer: "A",
    explanation: "$0\\cdot 3-1\\cdot(-2)=2$.",
  },
  {
    prompt: "Volume of the parallelepiped from columns of $\\begin{pmatrix}1&0&0\\\\0&2&0\\\\0&0&3\\end{pmatrix}$ equals:",
    options: ["$1$", "$5$", "$6$"],
    answer: "C",
    explanation: "Absolute value of the determinant $1\\cdot 2\\cdot 3=6$.",
  },

  {
    prompt: "The determinant of $\\begin{pmatrix}2&1\\\\3&4\\end{pmatrix}$ is:",
    options: ["$5$", "$11$", "$-5$"],
    answer: "A",
    explanation: "$2(4)-1(3)=5$.",
  },
  {
    prompt: "If two rows of a square matrix are equal, its determinant is:",
    options: ["$1$", "$0$", "Undefined"],
    answer: "B",
    explanation: "Equal rows make the rows linearly dependent.",
  },
  {
    prompt: "Swapping two rows of a matrix changes the determinant by a factor of:",
    options: ["$2$", "$0$", "$-1$"],
    answer: "C",
    explanation: "A single row swap reverses the determinant's sign.",
  },
  {
    prompt: "For triangular matrix $A$, $\\det(A)$ equals:",
    options: ["The product of its diagonal entries", "The sum of its diagonal entries", "Always $1$"],
    answer: "A",
    explanation: "The determinant of a triangular matrix is the diagonal product.",
  },
  {
    prompt: "A square matrix is invertible exactly when its determinant is:",
    options: ["Zero", "Nonzero", "Positive only"],
    answer: "B",
    explanation: "A nonzero determinant is equivalent to invertibility.",
  },
];

export const LA_M_INV_QUIZ = [
  {
    prompt: "The inverse of $\\begin{pmatrix}1&2\\\\3&4\\end{pmatrix}$ is:",
    options: ["$\\begin{pmatrix}-2&1\\\\3/2&-1/2\\end{pmatrix}$", "$\\begin{pmatrix}4&-2\\\\-3&1\\end{pmatrix}$", "$\\begin{pmatrix}1&-2\\\\-3&4\\end{pmatrix}$"],
    answer: "A",
    explanation: "$\\det=-2$; formula gives $(-1/2)\\begin{pmatrix}4&-2\\\\-3&1\\end{pmatrix}=\\begin{pmatrix}-2&1\\\\3/2&-1/2\\end{pmatrix}$.",
  },
  {
    prompt: "A $2\\times 2$ matrix is invertible iff its determinant is:",
    options: ["Equal to $1$", "Positive", "Nonzero"],
    answer: "C",
    explanation: "Invertibility is equivalent to $\\det\\ne 0$.",
  },
  {
    prompt: "$(AB)^{-1}$ equals:",
    options: ["$A^{-1}B^{-1}$", "$B^{-1}A^{-1}$", "$AB$"],
    answer: "B",
    explanation: "Inverse reverses the product order.",
  },
  {
    prompt: "If $A\\mathbf{x}=\\mathbf{b}$ and $A$ is invertible, then $\\mathbf{x}$ equals:",
    options: ["$A\\mathbf{b}$", "$A^{-1}\\mathbf{b}$", "$\\mathbf{b}A^{-1}$"],
    answer: "B",
    explanation: "Multiply both sides on the left by $A^{-1}$.",
  },
  {
    prompt: "The matrix $\\begin{pmatrix}1&2\\\\2&4\\end{pmatrix}$ fails to be invertible because:",
    options: ["It has positive entries", "It is symmetric", "Its determinant is $0$"],
    answer: "C",
    explanation: "$1\\cdot 4-2\\cdot 2=0$.",
  },
  {
    prompt: "Inverse of $\\begin{pmatrix}2&0\\\\0&5\\end{pmatrix}$ is:",
    options: ["$\\begin{pmatrix}1/2&0\\\\0&1/5\\end{pmatrix}$", "$\\begin{pmatrix}5&0\\\\0&2\\end{pmatrix}$", "$\\begin{pmatrix}2&0\\\\0&5\\end{pmatrix}$"],
    answer: "A",
    explanation: "Invert the diagonal entries.",
  },
  {
    prompt: "For invertible $A$, $A A^{-1}$ equals:",
    options: ["$A$", "$0$", "$I$"],
    answer: "C",
    explanation: "Definition of the inverse.",
  },
  {
    prompt: "Using the adjugate, $A^{-1}=(1/\\det A)\\operatorname{adj}A$ when:",
    options: ["$A$ is triangular", "$\\det A\\ne 0$", "$A$ is symmetric"],
    answer: "B",
    explanation: "The formula requires a nonzero determinant.",
  },
  {
    prompt: "Solve $\\begin{pmatrix}1&1\\\\0&1\\end{pmatrix}\\mathbf{x}=\\begin{pmatrix}3\\\\2\\end{pmatrix}$ using the inverse.",
    options: ["$\\mathbf{x}=\\begin{pmatrix}1\\\\2\\end{pmatrix}$", "$\\mathbf{x}=\\begin{pmatrix}2\\\\1\\end{pmatrix}$", "$\\mathbf{x}=\\begin{pmatrix}3\\\\2\\end{pmatrix}$"],
    answer: "A",
    explanation: "Inverse is $\\begin{pmatrix}1&-1\\\\0&1\\end{pmatrix}$; product gives $(1,2)$.",
  },
  {
    prompt: "If $A^{-1}=\\begin{pmatrix}0&1\\\\1&0\\end{pmatrix}$, then $A$ equals:",
    options: ["$\\begin{pmatrix}1&0\\\\0&1\\end{pmatrix}$", "$\\begin{pmatrix}0&-1\\\\-1&0\\end{pmatrix}$", "$\\begin{pmatrix}0&1\\\\1&0\\end{pmatrix}$"],
    answer: "C",
    explanation: "This matrix is its own inverse.",
  },
  {
    prompt: "Gauss-Jordan finds $A^{-1}$ by row-reducing:",
    options: ["$[A\\mid I]$ to $[I\\mid A^{-1}]$", "$[A\\mid\\mathbf{0}]$", "$A$ alone to RREF"],
    answer: "A",
    explanation: "Augment with the identity and reduce.",
  },
  {
    prompt: "If $\\det A=-4$, then $\\det(A^{-1})$ equals:",
    options: ["$1/4$", "$-1/4$", "$4$"],
    answer: "B",
    explanation: "$1/\\det A=-1/4$.",
  },
  {
    prompt: "The inverse of $\\begin{pmatrix}1&0\\\\4&1\\end{pmatrix}$ is:",
    options: ["$\\begin{pmatrix}1&0\\\\-4&1\\end{pmatrix}$", "$\\begin{pmatrix}1&0\\\\4&-1\\end{pmatrix}$", "$\\begin{pmatrix}-1&0\\\\-4&-1\\end{pmatrix}$"],
    answer: "A",
    explanation: "Check product is $I$, or use the $2\\times 2$ formula.",
  },
  {
    prompt: "If $A$ is invertible and $AB=AC$, then:",
    options: ["$B=-C$", "$B=C$", "Nothing about $B$ and $C$"],
    answer: "B",
    explanation: "Multiply on the left by $A^{-1}$.",
  },
  {
    prompt: "For $A=\\begin{pmatrix}4&1\\\\1&1\\end{pmatrix}$, $A^{-1}$ equals:",
    options: ["$\\dfrac{1}{3}\\begin{pmatrix}4&-1\\\\-1&1\\end{pmatrix}$", "$\\begin{pmatrix}1&-1\\\\-1&4\\end{pmatrix}$", "$\\dfrac{1}{3}\\begin{pmatrix}1&-1\\\\-1&4\\end{pmatrix}$"],
    answer: "C",
    explanation: "$\\det=3$; adjugate formula gives $(1/3)\\begin{pmatrix}1&-1\\\\-1&4\\end{pmatrix}$.",
  },

  {
    prompt: "The inverse of the identity matrix $I$ is:",
    options: ["$0$", "$I$", "$-I$"],
    answer: "B",
    explanation: "$II=I$, so $I^{-1}=I$.",
  },
  {
    prompt: "If $A^{-1}$ exists, then $AA^{-1}$ equals:",
    options: ["$A$", "$0$", "$I$"],
    answer: "C",
    explanation: "The inverse is defined by multiplication to the identity.",
  },
  {
    prompt: "If $A$ and $B$ are invertible, $(AB)^{-1}$ equals:",
    options: ["$B^{-1}A^{-1}$", "$A^{-1}B^{-1}$", "$AB$"],
    answer: "A",
    explanation: "The inverse of a product reverses the multiplication order.",
  },
  {
    prompt: "A singular square matrix has:",
    options: ["Exactly two inverses", "No inverse", "Inverse equal to itself"],
    answer: "B",
    explanation: "Singular means noninvertible.",
  },
  {
    prompt: "For an invertible $A$, the equation $Ax=b$ has solution:",
    options: ["$x=Ab$", "$x=bA$", "$x=A^{-1}b$"],
    answer: "C",
    explanation: "Multiply the equation on the left by $A^{-1}$.",
  },
];

export const LA_M_RANK_QUIZ = [
  {
    prompt: "The rank of a matrix is:",
    options: [
      "The number of rows it has",
      "The number of pivots after you reduce it to staircase form",
      "The largest entry, ignoring sign",
    ],
    answer: "B",
    explanation:
      "Reduce the matrix and count the leading non-zero entries (the pivots). That count is the rank — it is also the number of rows, or columns, that carry new information.",
  },
  {
    prompt: "$\\operatorname{rank}(I_5)$ (the $5\\times 5$ identity) equals:",
    options: ["$5$", "$1$", "$25$"],
    answer: "A",
    explanation: "The identity is already in staircase form with a pivot in every one of its 5 columns, so the rank is 5.",
  },
  {
    prompt: "The rank of the $3\\times 3$ matrix of all zeros is:",
    options: ["$3$", "$1$", "$0$"],
    answer: "C",
    explanation: "There are no non-zero rows, so there are no pivots. Only the all-zeros matrix has rank 0.",
  },
  {
    prompt: "For a matrix with $m$ rows and $n$ columns, the rank can be at most:",
    options: ["The smaller of $m$ and $n$", "$m+n$", "$m\\times n$"],
    answer: "A",
    explanation: "You can't have more pivots than there are rows, and not more than there are columns, so the rank never passes the smaller of the two.",
  },
  {
    prompt: "$\\operatorname{rank}\\begin{pmatrix}1&2\\\\2&4\\end{pmatrix}$ equals:",
    options: ["$2$", "$1$", "$0$"],
    answer: "B",
    explanation: "Row 2 is exactly twice row 1, so it adds nothing new. Only one row carries information, so the rank is 1.",
  },
  {
    prompt: "A $5\\times 5$ matrix has rank $3$. How many independent solutions does $Ax=0$ have?",
    options: ["$2$", "$3$", "$5$"],
    answer: "A",
    explanation: "Adding-up rule: rank + (independent solutions of $Ax=0$) = number of columns. So $3 + ? = 5$ gives 2.",
  },
  {
    prompt: "A square $n\\times n$ matrix has an inverse exactly when its rank is:",
    options: ["$0$", "$n-1$", "$n$"],
    answer: "C",
    explanation: "Full rank (a pivot in every column) is the same as having an inverse, which is the same as $\\det A\\neq 0$.",
  },
  {
    prompt: "For any matrix, the number of independent rows and the number of independent columns are:",
    options: ["Always the same", "The same only for square matrices", "Not related"],
    answer: "A",
    explanation: "These two counts are always equal — that shared value is the rank.",
  },
  {
    prompt: "Doing row operations on a matrix changes its rank:",
    options: ["Not at all — the rank stays the same", "It can only go down", "It doubles"],
    answer: "A",
    explanation: "Row operations just rewrite the same information a different way, so the rank is unchanged. That's why reducing first is a safe way to find it.",
  },
  {
    prompt: "$\\operatorname{rank}\\begin{pmatrix}1&2&3\\\\2&4&6\\\\1&1&1\\end{pmatrix}$ equals:",
    options: ["$3$", "$2$", "$1$"],
    answer: "B",
    explanation: "Row 2 is $2\\times$ row 1, so it adds nothing. Rows 1 and 3 are different from each other, so 2 rows carry information and the rank is 2.",
  },
  {
    prompt: "A matrix with 4 rows and 6 columns has rank 4. Which statement is true?",
    options: [
      "All 6 columns are independent",
      "All 4 rows are independent",
      "The matrix has an inverse",
    ],
    answer: "B",
    explanation:
      "Rank 4 with 4 rows means every row carries new information. Six columns can't all be independent (there's only room for 4), and a non-square matrix never has an inverse.",
  },
  {
    prompt: "The columns of a matrix with $n$ columns are all independent exactly when the rank equals:",
    options: ["The number of rows", "$n$ (the number of columns)", "$0$"],
    answer: "B",
    explanation: "Rank $n$ means a pivot in every column, so no column repeats another and there are no free variables.",
  },
  {
    prompt: "For a square matrix, $\\det A\\neq 0$ means the same as:",
    options: ["$A$ has full rank", "$A$ is symmetric", "$A$ has rank $0$"],
    answer: "A",
    explanation: "Non-zero determinant, full rank, and “has an inverse” are three ways of saying the same thing.",
  },
  {
    prompt: "If every column of a matrix is a multiple of one fixed column, its rank is:",
    options: ["$0$", "$1$", "The number of columns"],
    answer: "B",
    explanation: "All the columns point along the same single direction, so only one column's worth of information is present: rank 1.",
  },
  {
    prompt: "How does the rank of a product $AB$ compare with the ranks of $A$ and $B$?",
    options: [
      "It is never bigger than the smaller of $\\operatorname{rank}(A)$ and $\\operatorname{rank}(B)$",
      "It equals $\\operatorname{rank}(A)+\\operatorname{rank}(B)$",
      "It always equals $\\operatorname{rank}(A)$",
    ],
    answer: "A",
    explanation: "Multiplying can lose information but never create it, so the product's rank can't beat either factor's rank.",
  },

  {
    prompt: "The rank of a matrix equals the number of:",
    options: ["Rows only", "Zero entries", "Pivot positions"],
    answer: "C",
    explanation: "Row reduction reveals one pivot for each independent direction.",
  },
  {
    prompt: "A $3\\times5$ matrix can have rank at most:",
    options: ["$3$", "$5$", "$15$"],
    answer: "A",
    explanation: "Rank cannot exceed the smaller matrix dimension.",
  },
  {
    prompt: "If a $4\\times4$ matrix has rank $4$, it is:",
    options: ["Singular", "Invertible", "The zero matrix"],
    answer: "B",
    explanation: "Full rank in a square matrix is equivalent to invertibility.",
  },
  {
    prompt: "A zero matrix has rank:",
    options: ["$1$", "Equal to its number of rows", "$0$"],
    answer: "C",
    explanation: "There are no nonzero rows or pivot columns.",
  },
  {
    prompt: "For an $m\\times n$ matrix, rank equals the dimension of its:",
    options: ["Column space and row space", "Null space only", "Diagonal only"],
    answer: "A",
    explanation: "Row rank and column rank are equal.",
  },
];
